import { Toaster as Sonner, toast } from 'sonner';

/**
 * Toasts confirm an action the user just took ("Invitation sent."). They are
 * NEVER the only report of a failed page load — render InlineError in place.
 */
export { toast };

export function Toaster() {
  return (
    <Sonner
      position="bottom-right"
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: 'flex flex-wrap items-center gap-2 rounded-card border border-line bg-surface p-3 text-sm text-fg shadow-pop w-[356px] max-w-[calc(100vw-32px)]',
          title: 'font-medium',
          description: 'text-muted',
          actionButton: 'rounded-ctl border border-accent bg-accent px-2.5 h-7 text-xs font-medium text-on-accent',
          cancelButton: 'rounded-ctl border border-line bg-surface px-2.5 h-7 text-xs',
          error: '[&_[data-icon]]:text-neg-ink',
          success: '[&_[data-icon]]:text-pos-ink',
        },
      }}
    />
  );
}
